// extracted by mini-css-extract-plugin
module.exports = {"picture":"ABcj"};